var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 1.6665H5.00004C4.55801 1.6665 4.13409 1.8421 3.82153 2.15466C3.50897 2.46722 3.33337 2.89114 3.33337 3.33317V16.6665C3.33337 17.1085 3.50897 17.5325 3.82153 17.845C4.13409 18.1576 4.55801 18.3332 5.00004 18.3332H15C15.4421 18.3332 15.866 18.1576 16.1786 17.845C16.4911 17.5325 16.6667 17.1085 16.6667 16.6665V7.49984L10.8334 1.6665Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 1.6665V7.49984H16.6667",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d396e892ab490d09f7d895ebfe33d2a5.svg";
export { ForwardRef as ReactComponent };